import { app, api } from '../env'
import { AsyncAction, setIsEnabledForDevice } from '../state'
import { isBelowIOS16AndSafari16 } from './device'

export const canUseApplePay = (): AsyncAction<void> => async (dispatch) => {
  const { APPLE_PAY_ACQUIRING_MERCHANT_ID } = app

  const isSecure = window?.location?.protocol === 'https:'
  if (isSecure) {
    try {
      const hasApplePaySession = typeof (window as any).ApplePaySession !== 'undefined'
      const hasApplePaySetupWithActiveCard = (await (window as any).ApplePaySession?.canMakePaymentsWithActiveCard(APPLE_PAY_ACQUIRING_MERCHANT_ID)) === true
      const eligibleDeviceVersion = !isBelowIOS16AndSafari16()
      dispatch(setIsEnabledForDevice(hasApplePaySession && hasApplePaySetupWithActiveCard && eligibleDeviceVersion))
    } catch (e) {
      dispatch(setIsEnabledForDevice(false))
    }
  } else {
    dispatch(setIsEnabledForDevice(false))
  }
}

export const getDomain = (): string => {
  const url: string = api.PORTAL_API_BASE_URL

  if (url.includes('localhost')) {
    return 'localhost'
  }

  const urlItems = url.split('.')
  const urlItemsLength = urlItems.length

  if (
    urlItems[urlItemsLength - 1]?.length === 2 &&
    (urlItems[urlItemsLength - 3]?.includes('afterpay') || urlItems[urlItemsLength - 3]?.includes('clearpay'))
  ) {
    return urlItems.slice(-3).join('.')
  } else {
    return urlItems.slice(-2).join('.')
  }
}
